import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';
import * as moment from 'moment';

@Injectable({
	providedIn: 'root'
})
export class MochilaService {
	private data = null;
	private url = environment.serviceApi;
	constructor(public http: Http) { }

	getMochilas(ordem = null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/mochila' + (ordem ? '/ordem/' + ordem : ''))
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	getMochilasRegiao(usuario_id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/mochila/unidadeUsuario/' + usuario_id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	getByFiltrarMochila(usuario_id, filtro={}, pagina=1) {
		let params = '';

		for (let f in filtro) {
			let val = filtro[f];
			if (val) {
				let aux = f.split('___');
				if (aux[1] == 'data_i' || aux[1] == 'data_f')
					val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');

				params += (params == '')? '?' : '&';
				params += f + "=" + val;
			}
		}

		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/mochila/filtrar/' + usuario_id + '/' + pagina + params)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
				err => {
					reject(err);
				});
		});
	}

	getMochila(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/mochila/' + id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	getMochilaPorUnidade(unidade_id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/mochila/unidade/' + unidade_id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	criaMochila(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/mochila', {
				mochila_codigo: data.mochila_codigo,
				mochila_nome: data.mochila_nome,
				tipo_mochila_id: data.tipo_mochila_id,
				cliente_id: data.cliente_id,
				unidade_id: data.unidade_id,
				produtos: data.produtos
			})
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	editaMochila(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/mochila/' + data.mochila_id, {
				mochila_codigo: data.mochila_codigo,
				mochila_nome: data.mochila_nome,
				tipo_mochila_id: data.tipo_mochila_id,
				cliente_id: data.cliente_id,
				unidade_id: data.unidade_id,
				produtos: data.produtos
			})
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	apagaMochila(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/mochila/' + id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}
}
